import { useSelector } from 'react-redux'
import { RootState } from 'store/store'

import Sidebar from '../../../components/Sidebar'
import CallBadgeContainer from './call-badge-container'
import CallNumberAndDuration from './call-number-and-duration'
import CallerAccountName from './caller-account-name'
import CallerContactName from './caller-contact-name'
import TransferHistoryContainer from './transfer-history-container'

const CallInfoSidebar = () => {
  const {
    phoneNumber,
    startDate,
    contactName,
    accountName,
    leadName,
    invoiceCount,
    quoteCount,
    isNewCustomer,
    isVIP,
    accountId,
    leadId,
    contactId,
    preName,
  } = useSelector((state: RootState) => state.callDetail.callData)

  return (
    <Sidebar>
      <div className="border-b-2 p-7">
        <CallNumberAndDuration
          phoneNumber={phoneNumber}
          startDate={startDate}
        />
        <CallerContactName
          id={contactId || leadId}
          etc={contactId ? 2 : 4}
          name={contactName || leadName}
          isLead={!!leadName}
          preName={preName}
        />
        <CallerAccountName id={accountId} etc={1} name={accountName} />
        <CallBadgeContainer
          isNewCustomer={isNewCustomer}
          isVIP={isVIP}
          invoiceCount={invoiceCount}
          quoteCount={quoteCount}
        />
      </div>
      <div className="p-8">
        <TransferHistoryContainer />
      </div>
    </Sidebar>
  )
}

export default CallInfoSidebar
